// src/components/Admin/StoreFormModal.js
"use client";

import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import api from "../../services/api";
import { toast } from "react-toastify";

const StoreFormModal = ({ show, onHide, store, categories, onSuccess }) => {
	const [name, setName] = useState("");
	const [slug, setSlug] = useState("");
	const [phone, setPhone] = useState("");
	const [address, setAddress] = useState("");
	const [description, setDescription] = useState("");
	const [ownerName, setOwnerName] = useState("");
	const [ownerMobile, setOwnerMobile] = useState("");
	const [categoryId, setCategoryId] = useState("");
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (store) {
			setName(store.name || "");
			setSlug(store.slug || "");
			setPhone(store.phone || "");
			setAddress(store.address || "");
			setDescription(store.description || "");
			setOwnerName(store.ownerName || "");
			setOwnerMobile(store.ownerMobile || "");
			setCategoryId(store.storeCategories?.[0]?.categoryId || "");
		} else {
			setName("");
			setSlug("");
			setPhone("");
			setAddress("");
			setDescription("");
			setOwnerName("");
			setOwnerMobile("");
			setCategoryId("");
		}
	}, [store]);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);

		try {
			let res;
      let storeId;

			if (store) {
				// ویرایش
				await api.patch(`/admin/stores/${store.id}`, { name, slug, phone, address, description, ownerName, ownerMobile });
        storeId = store.id;
			} else {
				// افزودن جدید
				res = await api.post("/admin/stores", { name, slug, phone, address, description, ownerName, ownerMobile });
        storeId = res.data.id;
			}

      if (categoryId) {
        if(store?.storeCategories?.length) {
          // قبلا دسته داشته → ویرایش
					await api.patch(`/store-categories/${store.id}`, {
						storeId,
						categoryId: Number(categoryId),
					});
        }
        else {
          // دسته جدید
					await api.post("/store-categories", {
						storeId,
						categoryId: Number(categoryId),
					});
        }
      }
      toast.success(store ? "فروشگاه ویرایش شد" : "فروشگاه جدید اضافه شد");


			onSuccess();
			onHide();
		} catch (err) {
			toast.error(err.response?.data?.message || "خطا در ذخیره فروشگاه");
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal show={show} onHide={onHide}>
			<Form onSubmit={handleSubmit}>
				<Modal.Header closeButton>
					<Modal.Title>{store ? "ویرایش فروشگاه" : "افزودن فروشگاه"}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form.Group className="mb-3">
						<Form.Label>نام فروشگاه</Form.Label>
						<Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} required />
					</Form.Group>
					<Form.Group className="mb-3">
						<Form.Label>شناسه یکتا</Form.Label>
						<Form.Control type="text" value={slug} onChange={(e) => setSlug(e.target.value)} required />
					</Form.Group>
					<Form.Group className="mb-3">
						<Form.Label>دسته محصول فروشگاه</Form.Label>
						<Form.Select value={categoryId} onChange={(e) => setCategoryId(e.target.value)}>
							<option value="">انتخاب دسته</option>

							{categories?.map((c) => (
								<option key={c.id} value={c.id}>
									{c.title}
								</option>
							))}
						</Form.Select>
					</Form.Group>
					<Form.Group className="mb-3">
						<Form.Label>شماره تلفن</Form.Label>
						<Form.Control type="text" value={phone} onChange={(e) => setPhone(e.target.value)} required />
					</Form.Group>
					<Form.Group className="mb-3">
						<Form.Label>آدرس</Form.Label>
						<Form.Control type="text" value={address} onChange={(e) => setAddress(e.target.value)} required />
					</Form.Group>
					<Form.Group className="mb-3">
						<Form.Label>توضیحات</Form.Label>
						<Form.Control type="text" value={description} onChange={(e) => setDescription(e.target.value)} required />
					</Form.Group>
					<Form.Group className="mb-3">
						<Form.Label>نام مدیر فروشگاه</Form.Label>
						<Form.Control type="text" value={ownerName} onChange={(e) => setOwnerName(e.target.value)} />
					</Form.Group>
					<Form.Group className="mb-3">
						<Form.Label>شماره موبایل</Form.Label>
						<Form.Control type="tel" value={ownerMobile} onChange={(e) => setOwnerMobile(e.target.value)} />
					</Form.Group>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={onHide}>
						انصراف
					</Button>
					<Button type="submit" variant="primary" disabled={loading}>
						{loading ? "در حال ذخیره..." : "ذخیره"}
					</Button>
				</Modal.Footer>
			</Form>
		</Modal>
	);
};

export default StoreFormModal;
